import PropTypes from 'prop-types';
import React from 'react';
// material-ui
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Grid, Menu, MenuItem, Typography } from '@material-ui/core';

// project imports
import MainCard from '../../../common/MainCard';
// assets
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
// 数字变化动画
import TweenOne from 'rc-tween-one';
import Children from 'rc-tween-one/lib/plugin/ChildrenPlugin';
TweenOne.plugins.push(Children);

// style constant
const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: theme.palette.secondary.light,
    color: '#fff',
    overflow: 'hidden',
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '210px',
      height: '210px',
      background: theme.palette.secondary.main,
      borderRadius: '50%',
      top: '-85px',
      right: '-95px',
      [theme.breakpoints.down('xs')]: {
        top: '-105px',
        right: '-140px'
      }
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      width: '210px',
      height: '210px',
      background: theme.palette.secondary.main,
      borderRadius: '50%',
      top: '-125px',
      right: '-15px',
      opacity: 0.5,
      [theme.breakpoints.down('xs')]: {
        top: '-155px',
        right: '-70px'
      }
    }
  },
  content: {
    padding: '20px !important'
  },
  avatar: {
    ...theme.typography.commonAvatar,
    ...theme.typography.largeAvatar,
    backgroundColor: theme.palette.secondary.main,
    marginTop: '8px'
  },
  cardHeading: {
    fontSize: '2.125rem',
    fontWeight: 500,
    marginRight: '8px',
    marginTop: '14px',
    marginBottom: '6px'
  },
  subHeading: {
    fontSize: '1rem',
    fontWeight: 500,
    color: theme.palette.secondary.contrastText
  },
}));

//===========================|| DASHBOARD DEFAULT - TRANSACTION BOX ||===========================//

const TransactionBox = ({ txCount }) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <MainCard border={false} className={classes.card} contentClass={classes.content}>
        <Grid container direction="column">
          <Grid item>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Avatar variant="rounded" className={classes.avatar}>
                  <AssignmentOutlinedIcon fontSize="inherit" />
                </Avatar>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container alignItems="center">
              <Grid item>
                <Typography className={classes.cardHeading}>
                  <TweenOne
                    animation={{
                      Children: {
                        value: txCount,
                        floatLength: 0,
                      },
                      duration: 700,
                    }}
                  >0</TweenOne>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx={{ mb: 1.25 }}>
            <Typography className={classes.subHeading}>交易量</Typography>
          </Grid>
        </Grid>
      </MainCard>
    </React.Fragment>
  );
};

export default TransactionBox;
